module.exports = __webpack_public_path__ + "images/help_v2/guide-members-e36f5685859d872a50204f9eeaa6f516.png";